import React from 'react';

import type { SVGProps } from 'react';

/**
 * The pause bars alone, without PauseIcon's r=11.5 circle plate.
 *
 * PauseIcon draws 1-unit bars on a 0 0 24 24 canvas because the plate supplies
 * the optical mass. Transplanted bare at 18px those bars land at 0.75px wide —
 * roughly a sixth of the mass of the glyphs beside them in a control tile. The
 * viewBox is cropped to the glyph instead of redrawing the path, which puts the
 * bars at 1.5px x 13.5px, and the redundant 0.5 stroke is dropped.
 */
export const PauseGlyph: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="7.5 6 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 16.5C9.77614 16.5 10 16.2761 10 16V8C10 7.72386 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.72386 9 8V16C9 16.2761 9.22386 16.5 9.5 16.5Z"
      fill="currentColor"
    />
    <path
      d="M14.5 16.5C14.7761 16.5 15 16.2761 15 16V8C15 7.72386 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.72386 14 8V16C14 16.2761 14.2239 16.5 14.5 16.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PauseIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="11.5"
      transform="matrix(1 0 0 -1 0 24)"
      fill="white"
      stroke="#CCCAD7"
    />
    <path
      d="M9.5 16.5C9.77614 16.5 10 16.2761 10 16V8C10 7.72386 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.72386 9 8V16C9 16.2761 9.22386 16.5 9.5 16.5Z"
      fill="#2C2543"
    />
    <path
      d="M14.5 16.5C14.7761 16.5 15 16.2761 15 16V8C15 7.72386 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.72386 14 8V16C14 16.2761 14.2239 16.5 14.5 16.5Z"
      fill="#2C2543"
    />
    <path
      d="M9.5 16.5C9.77614 16.5 10 16.2761 10 16V8C10 7.72386 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.72386 9 8V16C9 16.2761 9.22386 16.5 9.5 16.5Z"
      stroke="#2C2543"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M14.5 16.5C14.7761 16.5 15 16.2761 15 16V8C15 7.72386 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.72386 14 8V16C14 16.2761 14.2239 16.5 14.5 16.5Z"
      stroke="#2C2543"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
  </svg>
);
